var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#3B5998"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94026 3.38062H8.99776V6.68924L7.94026 5.58505V3.38062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38119 4.49617H6.16501C7.10832 5.48336 8.05557 6.46886 8.99888 7.45829C9.54507 6.89073 10.0896 6.31923 10.6335 5.74998C11.0357 5.33317 11.4362 4.91411 11.8373 4.49561H14.6143C13.3183 5.80623 12.024 7.11798 10.7274 8.42748C10.5913 8.56417 10.4546 8.70198 10.3213 8.84036C10.3539 8.87523 10.3888 8.90954 10.4181 8.94667L14.2268 12.7975L14.6154 13.189H12.4611C12.4054 13.189 12.3497 13.1924 12.2951 13.1851C12.1416 13.1806 11.9874 13.1874 11.8339 13.1817C11.5554 12.8943 11.2804 12.6029 11.0019 12.3144C10.4546 11.7451 9.90957 11.1725 9.36226 10.6021C9.24076 10.4761 9.12207 10.3467 8.99776 10.2241C8.73338 10.5054 8.46226 10.7827 8.19619 11.0639L6.69038 12.6355C6.51488 12.8184 6.34163 13.0023 6.16501 13.1817C6.01313 13.1862 5.86013 13.1817 5.70713 13.184C5.61994 13.1947 5.53163 13.1874 5.44444 13.1896H3.38063L7.46888 9.05523C7.53919 8.98435 7.60894 8.91292 7.67701 8.84036L3.38119 4.49617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 10.9861C9.35214 11.359 9.70876 11.728 10.062 12.0998C10.0643 12.835 10.062 13.5691 10.062 14.3048H8.99889C8.99889 13.1984 8.99889 12.0925 9.00114 10.9861H9.00001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.5dcfe5fe007eb67923361ebbb60bc210.svg";
export { ForwardRef as ReactComponent };